// extracted by mini-css-extract-plugin
module.exports = {"rightContent":"rightContent-2rMaF0Rr","list":"list-2pIu4GIg","title":"title-1Y7ypWUx","ad_box":"ad_box-fsHnirFl","rightAd":"rightAd-2oFyHo3H"};